import http from "./http";
import dayjs, { type Dayjs } from 'plugins/dayjs';
import type { AsistenciaKinder } from "models/asistencia_kinder_model";

export const getKinderAssistanceByDate = async (date?: Dayjs) => {
  try {
    const filters = [];

    if (date) {
      filters.push(`fecha=${dayjs(date).format('YYYY-MM-DD')}`)
    }

    const items = await http.get(`/kinder/asistencia${filters.length ? ('?' + filters.join('&')) : ''}`);

    return items;
  } catch (error) {
    console.error("[get_asistencia]  Error -> ", error);
    return error;
  }
};

export const saveAssistance = async (data: AsistenciaKinder, date?:string) => {
  try {

    const filters = [];

    if (date) {
      filters.push(`fecha=${dayjs(date).format('YYYY-MM-DD')}`)
    }

    return await http.post(`/kinder/asistencia${filters.length ? ('?' + filters.join('&')) : ''}`, data);
  } catch (error) {
    console.error("[create] POST asistencia Error :: ", error);
    return error;
  }
};